/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityMelcoModelsUserPackage
 */
export interface IdentityMelcoModelsUserPackage {
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserPackage
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserPackage
     */
    melco_payment_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentityMelcoModelsUserPackage
     */
    product_code?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentityMelcoModelsUserPackage
     */
    is_auto_renew?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsUserPackage
     */
    purchase_type?: number;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsUserPackage
     */
    start_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof IdentityMelcoModelsUserPackage
     */
    end_date?: Date | null;
}

export function IdentityMelcoModelsUserPackageFromJSON(json: any): IdentityMelcoModelsUserPackage {
    return IdentityMelcoModelsUserPackageFromJSONTyped(json, false);
}

export function IdentityMelcoModelsUserPackageFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsUserPackage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'melco_payment_id': !exists(json, 'melco_payment_id') ? undefined : json['melco_payment_id'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'is_auto_renew': !exists(json, 'is_auto_renew') ? undefined : json['is_auto_renew'],
        'purchase_type': !exists(json, 'purchase_type') ? undefined : json['purchase_type'],
        'start_date': !exists(json, 'start_date') ? undefined : (json['start_date'] === null ? null : new Date(json['start_date'])),
        'end_date': !exists(json, 'end_date') ? undefined : (json['end_date'] === null ? null : new Date(json['end_date'])),
    };
}

export function IdentityMelcoModelsUserPackageToJSON(value?: IdentityMelcoModelsUserPackage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'melco_payment_id': value.melco_payment_id,
        'product_code': value.product_code,
        'is_auto_renew': value.is_auto_renew,
        'purchase_type': value.purchase_type,
        'start_date': value.start_date === undefined ? undefined : (value.start_date === null ? null : value.start_date.toISOString()),
        'end_date': value.end_date === undefined ? undefined : (value.end_date === null ? null : value.end_date.toISOString()),
    };
}


